module.exports = __webpack_public_path__ + "assets/img/ac9d-cv.svg";